module.exports = __webpack_public_path__ + "hero-expertise-left@2x.1k0fRoM5.png";